import { render } from "./dashboard-onboard.vue?vue&type=template&id=263c6e78"
import script from "./dashboard-onboard.vue?vue&type=script&lang=js"
export * from "./dashboard-onboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__